import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { KEYCLOAK_CONFIG } from "./config/settings";
import Keycloak from "keycloak-js";

const root = ReactDOM.createRoot(document.getElementById("root"));

const keycloak = new Keycloak({
  ...KEYCLOAK_CONFIG,
});

root.render(
  //<React.StrictMode>
  <ReactKeycloakProvider authClient={keycloak}>
    <App />
  </ReactKeycloakProvider>

  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
